<div class="atn-summit-org-chart-graph-wrapper">
  <div
    #container
    class="atn-summit-org-chart-graph"
  ></div>
  <div
    #navigatorContainer
    class="atn-summit-org-chart-navigator"
  ></div>
</div>
